import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class HeroLottie {
	constructor(container) {
		let playhead = { frame: 0 },
			animation = lottie.loadAnimation({
				container: container, // the dom element that will contain the animation
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: '/src/scripts/animations/HeroLottie/data.json', // the path to the animation json
			});

		animation.addEventListener('DOMLoaded', function () {});
	}
}
